import { combineLatest, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { isEmpty } from 'lodash';

export class ObservableUtil {
  public static combineBoolean(...o: Observable<boolean>[]): Observable<boolean> {
    return combineLatest(o).pipe(
      map((os) => {
        let val = false;
        for (const observable of os) {
          val = val || observable;
        }
        return val;
      }),
    );
  }

  public static takeWhenTruthy<T>(
    o: Observable<T | undefined | null>,
    predicate = (it: any) => !!it && !isEmpty(it),
  ): Observable<T> {
    return o.pipe(
      filter((it) => predicate(it)),
      take(1),
      map((it) => it!),
    );
  }
}
